'use strict'

function typesForPosition (rules, editingIndex) {

  const adding = editingIndex === null || editingIndex === undefined

  if (adding) {

    if (rules.length === 0) return ['if']

    const last = rules[rules.length - 1]

    if (last && last.type === 'else') return ['elseif']

    return ['elseif', 'else']
  }

  if (editingIndex <= 0) return ['if']

  const previous = rules[editingIndex - 1]

  if (previous && previous.type === 'else') return ['elseif']

  return ['elseif', 'else']
}

function ruleChainTypes (rules, editingIndex) {

  const list = Array.isArray(rules) ? rules : []
  const types = typesForPosition(list, editingIndex)

  if (editingIndex === null || editingIndex === undefined) return types

  const current = list[editingIndex] && list[editingIndex].type

  if (current && types.indexOf(current) === -1) return types.concat(current)

  return types
}

module.exports = { ruleChainTypes }
